export const FETCH_TICKET = 'FETCH_TICKET'
export const GET_TICKET = 'GET_TICKET'
export const ADD_TICKET = 'ADD_TICKET'
export const UPDATE_TICKET = 'UPDATE_TICKET'
export const ADD_COMMENT = 'ADD_COMMENT'

